import { inject, observer } from 'mobx-react';
import React from 'react';

import { MenuItem, Select } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';

@inject('scanWizardStore')
@observer
export default class OS extends React.Component {
    render() {
        const { osType, supportedOS, setOSType, next } = this.props.scanWizardStore;

        return (
            <div style={{ padding: 40, display: 'flex', justifyContent: 'center', textAlign: 'center' }}>
                <FormControl style={{ minWidth: '180px' }}>
                    <InputLabel htmlFor="age-simple">Select OS family</InputLabel>
                    <Select
                        value={osType}
                        onChange={(e) => {
                            setOSType(e.target.value);
                            next();
                        }}
                    >
                        {supportedOS.map((o) => (
                            <MenuItem key={o} value={o} style={{ textTransform: 'capitalize' }}>
                                {o} - based
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        );
    }
}
